<template>
  <component :is="is" v-if="label" :for="forInput" class="font-medium text-gray-900 text-sm/6 dark:text-gray-100 mb-2 flex items-center gap-x-1">
    <span>{{ label }}</span>
    <span v-if="required" class="text-red-500">*</span>
  </component>
</template>

<script setup lang="ts">
  defineProps({
    label: { type: String, default: '' },
    is: { type: String, default: 'label' },
    forInput: { type: String, default: null },
    required: { type: Boolean, default: false },
  });
</script>
